import React, { useEffect } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { useDispatch, useSelector } from "react-redux";
import { Switch } from "react-router-dom";
import { getPatientNotification } from "../actions/dashboardAction";
import ErrorFallback from "../components/FallbackComponent";
import FullScriptOauth from "../components/FullScriptOauth";
import Header from "../components/Header";
import SideMenu from "../components/SideMenu";
import Contact from "../pages/Contact";
import CreatePrescription from "../pages/CreatePrescription";
import CustomFormulaBuilder from "../pages/CustomFormulaBuilder";
import Dashboard from "../pages/Dashboard";
import Faq from "../pages/Faq";
import PatientFaq from "../pages/Faq/patientFaq";
import Formula from "../pages/Formula";
import FullscriptPage from "../pages/Fullscript";

import Order from "../pages/Order";
import PatientInfo from "../pages/PatientInfo";
import PatientOrder from "../pages/PatientOrder";
import Patients from "../pages/Patients";
import Practitioners from "../pages/Practitioners";
import PractitionerInfo from "../pages/Practitioners/PractitionerInfo";
import Prescriptions from "../pages/Prescriptions";
import Profile from "../pages/Profile";
import ShoppingCart from "../pages/ShoppingCart";
import Store from "../pages/Store/store";
import Subscription from "../pages/Subscription";
import PrivateRoute from "../routes/PrivateRoute";
import { getUserDetail } from "../utils/helper";
import history from "../utils/history";
import SalesOrder from "../pages/SalesOrder";
import { getPractitionerListForAdmin } from "../actions/practitionerAction";
import TwoFAsetup from "../pages/TwoFAsetup";
const PrivateLayout = (props) => {
  const role = useSelector((state) => state.role.role);
  const dispatch = useDispatch();

  useEffect(() => {
    if (getUserDetail()) {
      dispatch(getPatientNotification(role?.val));
      if (role?.val == 6) {
        dispatch(getPractitionerListForAdmin());
      }
    }
  }, [dispatch, role]);

  return (
    <>
      <Header showUserSection={true} />
      <SideMenu />
      <div className="base-container">
        <ErrorBoundary
          FallbackComponent={ErrorFallback}
          onReset={() => history.push("/app")}
        >
          <Switch>
            <PrivateRoute component={Dashboard} path="/app" exact={true} />
            <PrivateRoute
              component={Contact}
              path="/app/contact"
              exact={true}
            />
            <PrivateRoute
              component={FullScriptOauth}
              path="/app/fullscript"
              exact={true}
            />
            {/* <PrivateRoute component={Store} path="/app/store" exact={true} /> */}
            <PrivateRoute
              component={Patients}
              path="/app/patients"
              exact={true}
            />
            <PrivateRoute
              component={Practitioners}
              path="/app/practitioners"
              exact={true}
            />

            <PrivateRoute
              component={Profile}
              path="/app/profile"
              exact={true}
            />

            <PrivateRoute
              component={PatientInfo}
              path="/app/patient/info"
              exact={true}
            />
            <PrivateRoute
              component={PractitionerInfo}
              path="/app/practitioner/info"
              exact={true}
            />
            <PrivateRoute
              component={Prescriptions}
              path="/app/prescriptions"
              exact={true}
            />

            {role?.val === 1 ? (
              <PrivateRoute component={Faq} path="/app/faq" exact={true} />
            ) : (
              <PrivateRoute
                component={PatientFaq}
                path="/app/faq"
                exact={true}
              />
            )}
            <PrivateRoute
              component={CreatePrescription}
              path="/app/prescription"
              exact={true}
            />
            {role?.val === 3 ? (
              <PrivateRoute
                component={PatientOrder}
                path="/app/orders"
                exact={true}
              />
            ) : (
              <PrivateRoute component={Order} path="/app/orders" exact={true} />
            )}
            <PrivateRoute
              component={SalesOrder}
              path="/app/salesorder"
              exact={true}
            />
            <PrivateRoute
              component={ShoppingCart}
              path="/app/shopping"
              exact={true}
            />
            <PrivateRoute
              component={Formula}
              path="/app/formulas"
              exact={true}
            />
            <PrivateRoute
              component={CustomFormulaBuilder}
              path="/app/formulas/create"
              exact={true}
            />
            <PrivateRoute
              component={Subscription}
              path="/app/subscription"
              exact={true}
            />
            <PrivateRoute component={TwoFAsetup} path="/app/2fa" exact={true} />
          </Switch>
        </ErrorBoundary>
      </div>
    </>
  );
};

export default PrivateLayout;
